import { ImagePlus } from "lucide-react";
import { useTranslation } from "react-i18next";

import { cn } from "~/shared/lib/utils";

interface ChatDropOverlayProps {
    isDragOver: boolean;
}

// Полупрозрачный full-area overlay поверх main-области чата (sibling
// рендеру messages + prompt). Появляется когда юзер тащит файл в окно
// чата — даёт визуальное подтверждение что drop сработает.
export function ChatDropOverlay({ isDragOver }: ChatDropOverlayProps) {
    const { t } = useTranslation("chat");
    return (
        <div
            // pointer-events-none чтобы overlay не перехватывал dragenter/leave
            // у parent'а — иначе counter в useChatDropZone начинает скакать.
            aria-hidden
            className={cn(
                "pointer-events-none absolute inset-0 z-20 flex items-center justify-center",
                "bg-zinc-950/70 backdrop-blur-sm transition-opacity duration-150",
                isDragOver ? "opacity-100" : "opacity-0",
            )}
        >
            <div className="flex flex-col items-center gap-3 rounded-2xl border-2 border-dashed border-violet-400/60 px-10 py-8 text-center">
                <ImagePlus className="h-10 w-10 text-violet-300" />
                <p className="text-base font-medium text-zinc-100">{t("prompt.dropZone.dragHint")}</p>
            </div>
        </div>
    );
}
